import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var switchStyle = function switchStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6;
  return css([".ant-switch.ant-switch{&.ant-switch-checked{background-color:", ";&.ant-switch-disabled{opacity:1;}}&:active:after{width:18px;height:18px;}}"], primary6);
};
export default switchStyle;